import { Mesh } from 'three';

export interface IMesh {
  uuid?: string;
  name?: string;
  config: IMeshConfiguration
}

export class IMeshConfiguration {

  color?: string;
  metalness?: number;
  roughness?: number;
}

export class MeshConfiguration {

  color: string;
  metalness: number;
  roughness: number;
}

export default class MeshModel implements IMesh {

  uuid: string;
  name: string;
  config: MeshConfiguration = {color: '#fafafa', metalness: 0.2, roughness: 0.3};

  constructor(mesh: Mesh) {

    this.uuid = mesh.uuid;
    this.name = mesh.name;

    if(mesh.material) {
      this.config['color'] = (mesh.material as any).color.getHexString();
      this.config['roughness'] = (mesh.material as any).roughness;
      this.config['metalness'] = (mesh.material as any).metalness;
    }
  }

  updateConfig(config: IMeshConfiguration) {
    for(const key of Object.keys(config)) {
      if((config as any)[key]) {
				(this.config as any)[key] = (config as any)[key];
			}
    }
  }
}
